'use client';

import {Link} from '@mui/material';
import {styled} from '@mui/material/styles';
import {AppIcon, type IconDefinition, type SizeProp} from '../icon';

export interface SocialIconLinkProps {
  href: string;
  icon: IconDefinition;
  label: string;
  size?: SizeProp;
  onClick?: () => void;
}

const Root = styled(Link)(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: theme.radii.full,
  backgroundColor: theme.palette.colors.surface.neutral.inverseSubtle,
  color: theme.palette.colors.icon.neutral.inverse,
  textDecoration: 'none',
}));

export function SocialIconLink({href, icon, label, size = 'lg', onClick}: SocialIconLinkProps) {
  return (
    <Root href={href} target="_blank" rel="noopener noreferrer" underline="none" onClick={onClick} aria-label={label}>
      <AppIcon icon={icon} size={size} aria-hidden />
    </Root>
  );
}

SocialIconLink.displayName = 'SocialIconLink';
